import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'
import { StoreFrontOrder } from 'lib/graphql/storefront'

const initialState: StoreFrontOrder = {
  id: '',
  approval: null,
  approvalRequired: null,
  bookingDates: null,
  discount: null,
  discountPrice: null,
  entryFee: null,
  numberOfPeople: null,
  saleOfGoods: null,
  serialNumber: null,
  status: null,
  orderNumber: null,
  originalSubTotalPrice: null,
  originalTotalPrice: null,
  originalTotalTax: null,
  subTotalPrice: null,
  totalTax: null,
  totalPrice: null,
  specialPriceIncluded: null,
  createdAt: null,
  updatedAt: null,
  refund: null,
  purpose: null,
  period: null,
}

// Slice
const OrderCreateSuccessSlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    setOrderCreateSuccess: (state, action: PayloadAction<StoreFrontOrder>) => {
      const { payload } = action
      state.id = payload.id
      state.discount = payload.discount
      state.discountPrice = payload.discountPrice
      state.serialNumber = payload.serialNumber
      state.originalSubTotalPrice = payload.originalSubTotalPrice
      state.originalTotalPrice = payload.originalTotalPrice
      state.originalTotalTax = payload.originalTotalTax
      state.totalTax = payload.totalTax
      state.bookingDates = payload.bookingDates
      state.numberOfPeople = payload.numberOfPeople
      state.period = payload.period
      state.purpose = payload.purpose
      state.specialPriceIncluded = payload.specialPriceIncluded
    },
    resetOrderCreateSuccess: (state) => {
      if (state.id) {
        state.id = ''
        state.discount = null
        state.discountPrice = null
        state.serialNumber = null
        state.originalSubTotalPrice = null
        state.originalTotalPrice = null
        state.originalTotalTax = null
        state.totalTax = null
        state.bookingDates = null
        state.numberOfPeople = null
        state.period = null
        state.purpose = null
        state.specialPriceIncluded = null
      }
    },
  },
})

// Selectors
export const getOrderCreateSuccessSelector = (
  state: RootState
): StoreFrontOrder => state.orderCreateSuccess

// Actions
export const { setOrderCreateSuccess, resetOrderCreateSuccess } =
  OrderCreateSuccessSlice.actions

// Reducers
export default OrderCreateSuccessSlice.reducer
